<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{ dialogTitle }}</h2>
<!-- Error Message Display -->
<div *ngIf="errorMessage" class="error-message">
  <mat-error>{{ errorMessage }}</mat-error>
</div>

<mat-dialog-content>
  <form #organizationForm="ngForm" style="padding-top: 10px;">
    <div class="form-container">

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Organization Name</mat-label>
        <input
          matInput
          [(ngModel)]="organizationdata.organizationName"
          name="organizationName"
          required
          #organizationName="ngModel"
        />
        <mat-error *ngIf="organizationName.invalid && organizationName.touched">
          Organization Name is required
        </mat-error>
      </mat-form-field>

      <!-- Additional Fields -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>City</mat-label>
        <input
          matInput
          [(ngModel)]="organizationdata.city"
          name="city"
          required
          #city="ngModel"
        />
        <mat-error *ngIf="city.invalid && city.touched">City is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Province</mat-label>
        <input
          matInput
          [(ngModel)]="organizationdata.province"
          name="province"
          required
          #province="ngModel"
        />
        <mat-error *ngIf="province.invalid && province.touched">Province is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Postal Code</mat-label>
        <input
          matInput
          [(ngModel)]="organizationdata.postalCode"
          name="postalCode"
          required
          #postalCode="ngModel"
        />
        <mat-error *ngIf="postalCode.invalid && postalCode.touched">
          Postal Code is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Country</mat-label>
        <input
          matInput
          [(ngModel)]="organizationdata.country"
          name="country"
          required
          #country="ngModel"
        />
        <mat-error *ngIf="country.invalid && country.touched">Country is required</mat-error>
      </mat-form-field>
     <!-- Status Dropdown -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="organizationdata.status" name="status" required #status="ngModel">
          <mat-option *ngFor="let option of statusOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="status.invalid && status.touched">Status is required</mat-error>
      </mat-form-field>


      <!-- Primary Contact Section -->
     <!-- <ng-container *ngIf="!isEdit">
        <h3>Primary Contact</h3>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>User ID</mat-label>
          <input
            matInput
            [(ngModel)]="primaryContact.userName"
            name="primaryContactUserName"
            required
            #userName="ngModel"
          />
          <mat-error *ngIf="userName.invalid && userName.touched">User ID is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input
            matInput
            [(ngModel)]="primaryContact.password"
            type="password"
            name="primaryContactPassword"
            required
            #password="ngModel"
          />
          <mat-error *ngIf="password.invalid && password.touched">Password is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            [(ngModel)]="primaryContact.emailAddress"
            type="email"
            name="primaryContactEmail"
            required
            #emailAddress="ngModel"
          />
          <mat-error *ngIf="emailAddress.invalid && emailAddress.touched">
            Email is required and should be valid
          </mat-error>
        </mat-form-field>
      </ng-container>
    -->
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="organizationForm.invalid">SAVE</button>
  <button mat-raised-button mat-dialog-close (click)="onCancel()">CANCEL</button>
</mat-dialog-actions>
</div>
